import { Authentication, BaseRequest } from './core/baseRequest';
import { Token, TokenDynamicType } from 'acscp/api/models/token';

export abstract class TokenRequest extends BaseRequest<Token> {
    protected clientId: string;

    constructor(public username: string) {
        super('token', {}, TokenDynamicType, Authentication.None, 'v1');
        this.clientId = OAUTH_CLIENT_ID;
        this.addHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
}
